export class Constants {
	static pathListaAutPag = "/listaAutorizacaoPagamento";
	static home = "/home";

	static MENSAGEM_GED_SEM_ARQUIVOS_ID = "E610SISTEC0011-Não existe arquivo com esse ID no GED.";
	static MENSAGEM_GED_NAO_PENTENCE_CLIENTE = "E610SISTEC0010-Arquivo não pertence ao cliente.";

	static MENSAGEM_OBRIGATORIEDADE_DESALOCACAO =
		"Necessário escolher um motivo e/ou informar justificativa";
	static MENSAGEM_ERROR_SERVICO_DESALOCACAO = "Falha no serviço de Desalocar Laudo";

	static EXPAND_PROP = "&$expanded";
	
}

export const ADM_DIRETA = "Administração Direta";
export const ADM_INDIRETA = "Administração Indireta";
export const REGIME_NE = "Não Especificado";
export const ENCARGOS_NE = "Não Especificada";

export const OPCOES_REGIME_CONTRATACAO = [
  { value: ADM_DIRETA, label: ADM_DIRETA },
  { value: ADM_INDIRETA, label: ADM_INDIRETA },
  { value: REGIME_NE, label: REGIME_NE },
];

export const OPCOES_ENCARGOS_SOCIAIS = [
  { value: "Desonerada", label: "Desonerada" },
  { value: "Não Desonerada", label: "Não Desonerada" },
  { value: ENCARGOS_NE, label: ENCARGOS_NE },
];
